import 'bank-account-validator/src/banco_do_brasil_check_number_calculator';
import 'bank-account-validator/src/banco_do_brasil_validator';
import 'bank-account-validator/src/bank_account';
import 'bank-account-validator/src/banrisul_check_number_calculator';
import 'bank-account-validator/src/banrisul_validator';
import 'bank-account-validator/src/bradesco_check_number_calculator';
import 'bank-account-validator/src/bradesco_validator';
import 'bank-account-validator/src/citibank_validator';
import 'bank-account-validator/src/common_bank_account_validator';
import 'bank-account-validator/src/generic_bank_account_validator';
import 'bank-account-validator/src/hsbc_validator';
import 'bank-account-validator/src/itau_check_number_calculator';
import 'bank-account-validator/src/itau_validator';
import 'bank-account-validator/src/santander_validator';

export default window.Moip;
